<template>

    <div class="ta-c fz175 pt025 pb050">
        <h1 class="standard-title">Build my month <a href="#" @click.prevent="showInfoModal()" class="small" style="color: inherit"><i class="fa fa-question-circle"></i></a></h1>
        <div v-if="!has_data" class="fz085">
            <br><br>
            <span class="standard-loading-message">loading...</span>
        </div>
    </div>

    <div class="iwd-responsive-layout reverse-on-large calendar-inner" :class="{visible: has_data}">

        <section class="iwd-child-block iwd-span-55 mb2">
            <dashboard-calendar :offset_top="calc_offset_top" :context="'widget'"></dashboard-calendar>
        </section>

        <section class="iwd-child-block pending-list-wrapper">

            <calendar-pending-list-component></calendar-pending-list-component>

        </section>

    </div>

    <div class="modal-content-store">

        <h1 class="mb150">Build your monthly programme!</h1>

        <h2 class="mb150">You can use the calendar both to review your past progress and upcoming routines.</h2>

        <ul class="standard mb2">
            <li class="mb100">Use the toggle at the top right to switch between progress and future routines.</li>
            <li class="mb100">Either clear your library to take a quiz or manually place specific routines in your calendar from your private library.</li>
            <li class="mb100">Click on any routine from your selection to place this onto a specific calendar day.</li>
            <li class="mb100">Once placed, click the video icon to either change day, remove, or see more info.</li>
            <li class="mb100">If a day shows a book icon you&rsquo;ll be following the exercises from Roger&rsquo;s book on video. (You can modify these exercises
                <a href="/builder">here</a>).</li>
        </ul>

        <p><small>Having problems? Please reach out directly at <a href="mailto:info@roger.coach">info@roger.coach</a></small></p>

    </div>

</template>

<script>

var emitter = require('tiny-emitter/instance');

export default {
    props: {
        'context': String
    },
	data(){
		return {
			has_data: false,
            el_offset_top: 0,
            calc_offset_top: 0
        }
    },
    mounted()
    {
        if(this.context === 'static')
        {
            this.checkAndLoadData().then(()=>{
                this.el_offset_top = $('.dashboard-calendar')?.offset()?.top ?? null;
                this.attachScrollListeners();
            });
        }

    	emitter.on('calendarModalOpened', ()=>{
    		this.checkAndLoadData().then(()=>{
			    this.el_offset_top = $('.calendar-modal .dashboard-calendar')?.offset()?.top ?? null;
			    this.attachScrollListeners();
		    });
        });
    	emitter.on('calendarModalClosed', ()=>{
    		this.el_offset_top = $('.calendar-wrapper.calendar-static .dashboard-calendar')?.offset()?.top ?? null;
    		this.attachScrollListeners();
        });

        emitter.on('windowResized', ()=>{
        	this.attachScrollListeners();
        })
    },
    methods: {
    	checkAndLoadData()
        {
            return new Promise((resolve, reject) => {

                this.has_data = !!this.$store.getters.getMainData;

                if(!this.has_data)
                {
                    this.getUserData(['calendar']).then((response)=>{
                        this.has_data = true;
                        resolve(true);
                    }).catch((e) => {
                        throw new Error('An error occurred connecting with the server.');
                    });
                }else{
                	resolve(true);
                }
            }).catch((error)=>{
                reject(error);
            });
        },
		attachScrollListeners()
        {
        	this.calc_offset_top = 0;

            if(this.$store.getters.isDesktopScreen)
            {
                $('.modal-inner').on('scroll', ()=>{
                    this.doScroll('modal');
                });
                $(window).on('scroll', ()=>{
                    this.doScroll('window');
                });
            }else {
            	this.calc_offset_top = 0;
            	$(window).off('scroll');
            	$('.modal-inner').off('scroll');
            }
        },
        doScroll(ele)
        {
            let scroll_from_top;
            let comp;
            let caveat;
            let set;

            switch(ele)
            {
                case 'window':
                    scroll_from_top = $(window).scrollTop();
                    comp = this.el_offset_top;
                    caveat = (scroll_from_top + $('.calendar-wrapper.calendar-static .dashboard-calendar').outerHeight() + 10 >= $('#app>footer').offset().top);
                    set = scroll_from_top - this.el_offset_top;
                	break;
                case 'modal':
                	const modal_offset_top = $('.modal-inner').offset().top;
                	scroll_from_top = $('.modal-inner').scrollTop() + $(window).scrollTop();
                    comp = this.el_offset_top - modal_offset_top;
                    caveat = false;
                    set = scroll_from_top - this.el_offset_top + modal_offset_top;
                	break;
            }
            if(caveat)
            {
            	return;
            }
            if(scroll_from_top >= comp)
            {
                this.calc_offset_top = set
            }else {
            	this.calc_offset_top = 0;
            }
        },
        showInfoModal(){
            const media = {
                display: false,
                img_src: null
            };
            const content = $('.modal-content-store').html();
            emitter.emit('showModal', {media, content});
        }
    }

}

</script>
